import React from 'react';
import { Outlet } from 'react-router-dom';
import '../App.css';

const LayoutWithoutDash = () => {
  return (
    <div className="min-h-screen w-full">
      <main className="w-full h-full">
        <Outlet />
      </main>
    </div>
  );
};

export default LayoutWithoutDash;


